import React, { useState, useEffect, useContext } from 'react';
import AgreementNotificationService from "../../Controller/AgreementNotificationController";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { handleChange, handleSubmit } from "../../Controller/AgreementExpiryController";
import ContractFrequency from "../../../Setup/controller/ContractFrequencyController/ContractFrequencyController";
import AgreementService from "../../Controller/AgreementController";
import CreateAgreementNotification from './CreateAgreementNotification';
import HelpSite from "../../../Common/HelpLink";
function AgreementNotificationPage({ AgreementID }) {
    const navigate = useNavigate();
    AgreementID = localStorage.getItem('AgreementID');
    const [AggNotificationList, setAggNotificationData] = useState([]);
    const [AggList, setAggData] = useState([]);
    const { theme } = useContext(ThemeContext);
    const [modalInstance, setModalInstance] = useState(null);
    const [isClosed, SetIsClosed] = useState("0");

    const [currentAssetNotification, setCurrentAssetNotification] = useState(null);
    const [formData, setFormData] = useState({
        dt_NotifyExpiry: '', Is_Send_Notification: 0, FK_Contract_ID: AgreementID,
        NextCheckDate: '', CheckFrequency: 0, PK_ContractExpiry_ID: 0
    });
    const [ContractFrequecnyList, setContractFrequecny] = useState([]);
    const [checkboxState, setCheckboxState] = useState({});
    const [errors, setErrors] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const fetchAggNotifications = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await AgreementNotificationService.GetAllAgreementNotifications(redirectCallback, AgreementID);
            setAggNotificationData(data);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };
    const fetchAgreementDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (AgreementID > 0) {
                const agreementDetail = await AgreementService.GetAgreementByID(redirectCallback, AgreementID);
                if (agreementDetail[0].FK_Issue_ID > 0 || agreementDetail[0].FK_SalesOrder_ID > 0) {
                    SetIsClosed("1");
                }

            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchAgreementDetail();
        fetchAggNotifications();
        fetchContractFrequency();
        if (AgreementID > 0) {
            fetchAgreementByID();
        }
        else {
            setAggNotificationData([]);
            setFormData({
                dt_NotifyExpiry: '', Is_Send_Notification: 0, FK_Contract_ID: AgreementID,
                NextCheckDate: '', CheckFrequency: 0, PK_ContractExpiry_ID: 0
            })
        }
    }, [AgreementID]);

    const handleCreateAggNotificationClick = () => {
        setCurrentAssetNotification(null);
        setIsModalOpen(true);
    };
    const fetchContractFrequency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfContractFrequencies = await ContractFrequency.GetAllContractFrequency(redirectCallback);
            setContractFrequecny(listOfContractFrequencies);
        } catch (error) {
            console.error('Error fetching contract frequencies:', error);
        }
    };
    const fetchAgreementByID = async () => {
        try {
            const redirectCallback = () => navigate('/');

            const agreementList = await AgreementService.GetContractExpirey(redirectCallback, AgreementID);
            setFormData({
                dt_NotifyExpiry: new Date(agreementList[0].dt_NotifyExpiry).toISOString().split('T')[0],
                NextCheckDate: new Date(agreementList[0].NextCheckDate).toISOString().split('T')[0],
                Is_Send_Notification: agreementList[0].Is_Send_Notification,
                FK_Contract_ID: agreementList[0].FK_Contract_ID,
                CheckFrequency: agreementList[0].CheckFrequency,
                PK_ContractExpiry_ID: agreementList[0].PK_ContractExpiry_ID,
            });
        } catch (error) {
            console.error('Error fetching contract frequencies:', error);
        }
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (asset) => {
        setCurrentAssetNotification(asset); // Set the notification to be edited
        setIsModalOpen(true);
    };
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setFormData({ ...formData, [name]: checked ? 1 : 0 });
    };
    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this notification?");
        if (confirmed) {
            try {
                await AgreementNotificationService.DeleteAgreementNotifications(ID);
                fetchAggNotifications(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Agreement Notification:', error);
            }
        }
    };
    const handleSuccess = () => {
        fetchAggNotifications(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate(`/AgreementDetail?ID=${AgreementID}`);
            };
            formData.FK_Contract_ID = AgreementID;
            const message = await handleSubmit(event, formData, setFormData, setErrors);
            debugger;
            if (message == "Data saved successfully") {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
            fetchAgreementByID();
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };

    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3">
                <div className="col-xl-12" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                    <label htmlFor="contractNumber" className="col-sm-2 col-form-label">Expiry Notification:<span style={{ "color": "red" }}>*</span></label>
                    <div className="col-sm-4">
                        <input type="hidden" className="form-control" name="PK_ContractExpiry_ID" value={formData.PK_ContractExpiry_ID} onChange={handleFieldChange} />
                        <input
                            type="checkbox"
                            name="Is_Send_Notification"
                            className="form-check-input"
                            checked={formData.Is_Send_Notification === 1}
                            onChange={handleCheckboxChange}
                            disabled={isClosed === '1' || isClosed === 1}
                        />
                        <label style={{ "marginLeft": "18px" }} className="form-check-label" htmlFor="EmailNotification" >
                            Send Expiry Notification
                        </label>

                    </div>
                    <label htmlFor="dt_NotifyExpiry" className="col-sm-2 col-form-label">Expiry Date:<span style={{ "color": "red" }}>*</span></label>
                    <div className="col-sm-4">
                        <input type="date" className="form-control" name="dt_NotifyExpiry" value={formData.dt_NotifyExpiry}
                            onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                        {errors.dt_NotifyExpiry && <div style={{ color: 'red' }}>{errors.dt_NotifyExpiry}</div>}
                    </div>

                </div>
                <div className='row mb-3' style={{ "marginLeft": "0px" }}>
                    <label htmlFor="contractNumber" className="col-sm-2 col-form-label">Notification Frequency:<span style={{ "color": "red" }}>*</span></label>
                    <div className="col-sm-4">
                        <select
                            name="CheckFrequency"
                            className='form-control'
                            value={formData.CheckFrequency}
                            onChange={handleFieldChange}
                            disabled={isClosed === '1' || isClosed === 1}
                        >
                            <option value="0">Select Notification Frequency</option>
                            {ContractFrequecnyList.map((freq) => (
                                <option key={freq.ID} value={freq.ID}>
                                    {freq.ContractFrequency}
                                </option>
                            ))}
                        </select>
                        {errors.CheckFrequency && <div style={{ color: 'red' }}>{errors.CheckFrequency}</div>}
                    </div>
                    <label htmlFor="NextCheckDate" className="col-sm-2 col-form-label">Next Notification Date:<span style={{ "color": "red" }}>*</span></label>
                    <div className="col-sm-4">
                        <input type="date" className="form-control" name="NextCheckDate" value={formData.NextCheckDate}
                            onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                        {errors.NextCheckDate && <div style={{ color: 'red' }}>{errors.NextCheckDate}</div>}
                    </div>
                </div>

                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-12">
                        

                        <button style={{ "marginLeft": "3px",float:"right" }} type="submit" className="btn btn-primary" disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                             <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save

                        </button>
                        <button style={{float:"right"}} className='btn btn-primary btn-sm' onClick={handleCreateAggNotificationClick} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                            <i className="icofont-plus" aria-hidden="true"> Add New Email</i>
                        </button>
                    </div>

                </div>
            </form>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Email</th>
                                    <th>Other</th>
                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AggNotificationList.map((agreement, index) => (
                                    <tr key={agreement.PK_ContractNotifications_ID}>
                                        <td>{agreement.vc_Email}</td>
                                        <td>{agreement.vc_Other}</td>
                                        <td style={{ "textAlign": "right" }}>
                                            <button disabled={isClosed === '1' || isClosed === 1} className='text-info' style={{ "background": "none", "border": "none" }} onClick={() => handleEditClick(agreement)}>
                                                <i className="icofont-edit" aria-hidden="true"></i>
                                            </button>
                                            <button disabled={isClosed === '1' || isClosed === 1} style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(agreement.PK_ContractNotifications_ID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateAgreementNotification
                    agreement={currentAssetNotification}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    AgreementID={AgreementID}
                />
            )}
        </div>
    );
}

export default AgreementNotificationPage;
